import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import EditableToggle from './EditableToggle';
import adminpulse from '@/shared/utils/adminpulse';
const messages = defineMessages({
    InvalidEmail: {
        id: 'InvalidEmail',
        defaultMessage: 'Invalid email address',
    },
    FieldRequired: {
        id: 'FieldRequired',
        defaultMessage: 'This field is required',
    },
});
const EditableEmailTextbox = ({ onChange, value = null, readOnly = false, required = false, displayValue = null, displayClassName = '', }) => {
    const intl = useIntl();
    const [error, setError] = useState('');
    const handleSubmit = (editValue) => {
        if (!editValue && required) {
            setError(intl.formatMessage(messages.FieldRequired));
            return Promise.reject();
        }
        if (editValue && !adminpulse.isValidEmail(editValue)) {
            setError(intl.formatMessage(messages.InvalidEmail));
            return Promise.reject();
        }
        setError('');
        return onChange(editValue);
    };
    return (_jsx(EditableToggle, Object.assign({ onSubmit: handleSubmit, value: value, readOnly: readOnly, displayValue: displayValue, className: displayClassName, onModeChange: mode => {
            if (mode === 'display')
                setError('');
        } }, { children: ({ inputValue, handleChange, inputRef, submit, cancel, handleKeyDown }) => (_jsxs("div", { children: [_jsx("input", { type: "email", value: inputValue === null ? '' : inputValue, onChange: e => {
                        setError('');
                        handleChange(e);
                    }, ref: inputRef, onBlur: submit, onKeyDown: handleKeyDown, className: `form-control${error ? ' markedError' : ''}`, autoComplete: "off" }), error && _jsx("span", Object.assign({ className: "help-block text-danger" }, { children: error }))] })) })));
};
export default EditableEmailTextbox;
